var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07724 10.308C8.08658 11.1665 6.81919 11.6382 5.50835 11.6363C2.49306 11.6363 0.0488281 9.19211 0.0488281 6.17681C0.0488281 3.16151 2.49306 0.717285 5.50835 0.717285C8.52365 0.717285 10.9679 3.16151 10.9679 6.17681C10.9679 7.34296 10.6021 8.42395 9.9797 9.31058L8.23812 6.17681H9.87597C9.87589 5.17019 9.5281 4.19449 8.89144 3.41478C8.25478 2.63506 7.36834 2.0992 6.38206 1.89783C5.39578 1.69646 4.37022 1.84196 3.47887 2.3097C2.58752 2.77744 1.8851 3.53872 1.49043 4.46475C1.09576 5.39078 1.03307 6.4247 1.31298 7.39163C1.59288 8.35856 2.19818 9.19912 3.0265 9.77112C3.85481 10.3431 4.85528 10.6115 5.85866 10.5307C6.86204 10.45 7.80673 10.0251 8.53293 9.32805L9.07724 10.308Z",
    fill: "#173963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f472258eb67bc530288a992fc3a7f0c8.svg";
export { ForwardRef as ReactComponent };